import { IPriceOverwriteState, IUser, StateLoading } from "../pointOfSale.typings";

export const priceOverwriteState = {
	priceOverwrite: {
		users: {
			fetchStateLoading: {
				started: false,
				loading: false,
				success: false,
				hasError: false,
				errorMessage: "",
			} as StateLoading,
			users: [] as Array<IUser>,
		},
		userCanOverwrite: false,
		lastAuthenticatedUser: {} as IUser,
	} as IPriceOverwriteState,
};

const priceOverwriteReducer = () => {
	return {
		setUserCanOverwrite: (state, { payload }) => {
			state.priceOverwrite.userCanOverwrite = payload;
		},
		setLastAuthenticatedUser: (state, { payload }) => {
			state.priceOverwrite.lastAuthenticatedUser = payload;
		},
		fetchUsersWithRoleStart: (state, { payload }) => {
			return {
				...state,
				priceOverwrite: {
					...state.priceOverwrite,
					users: {
						...state.priceOverwrite.users,
						fetchStateLoading: {
							started: true,
							loading: true,
							success: false,
							hasError: false,
							errorMessage: "",
						},
					},
				},
			};
		},
		fetchUsersWithRoleComplete: (state, { payload }) => {
			return {
				...state,
				priceOverwrite: {
					...state.priceOverwrite,
					users: {
						fetchStateLoading: {
							started: true,
							loading: false,
							success: true,
							hasError: false,
							errorMessage: "",
						},
						users: payload.data as Array<IUser>,
					},
				},
			};
		},
		fetchUsersWithRoleFail: (state, { payload }) => {
			return {
				...state,
				priceOverwrite: {
					...state.priceOverwrite,
					users: {
						...state.priceOverwrite.users,
						fetchStateLoading: {
							started: true,
							loading: false,
							success: false,
							hasError: true,
							errorMessage: payload,
						},
					},
				},
			};
		},
	};
};

export default priceOverwriteReducer;
